import type { ReviewedStrategyDTO, SubscriptionAuthorizationDTO, OwnSignalExecutionTargetDTO } from '@/services/forexApi';

/** Presentation only: never use these labels to grant execution permission. */
export function authorizationLabel(value?: SubscriptionAuthorizationDTO): string {
  if (!value) return '授权状态暂不可用';
  if (value.state === 'revoked') return '策略授权已撤销';
  if (value.state === 'paused' || value.readiness === 'paused') return '策略授权已暂停';
  if (value.readiness === 'needs_reauthorization') return '策略已更新，需要重新授权';
  if (value.readiness === 'ready') return '当前策略已授权';
  return '策略授权待配置';
}

export function readinessLabel(value?: SubscriptionAuthorizationDTO): string {
  if (!value) return '执行就绪状态待核对';
  return value.effective_for_new_opens ? '已具备新开仓授权，仍需逐次准入' : '新开仓待就绪，请核对当前授权与账户状态';
}

export function sameReviewedStrategy(a: ReviewedStrategyDTO | null, b: ReviewedStrategyDTO | null): boolean {
  return !!a && !!b && a.strategy_ref.id === b.strategy_ref.id
    && a.strategy_ref.version === b.strategy_ref.version
    && a.strategy_ref.content_hash === b.strategy_ref.content_hash && a.risk_hash === b.risk_hash;
}

export function ownExecutionLabel(item: OwnSignalExecutionTargetDTO): string {
  if (item.result_phase === 'filled' && item.order_effect === 'filled') return 'Broker 成交已确认';
  if (item.command_status === 'unknown') return '执行结果待核对';
  if (item.command_status === 'received') return 'EA 已接收，尚未确认成交';
  if (item.command_status === 'submit_authorized') return '已授权提交，尚未确认成交';
  if (item.command_status === 'leased' || item.command_status === 'queued') return '待 EA 处理';
  if (item.target_state === 'blocked') return '本账号未通过执行准入';
  // A new/unknown command status is not evidence that no command was generated.
  if (item.command_id || item.command_status || item.result_phase) return '执行结果待核对';
  return '本账号尚未生成执行命令';
}
